import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { MaterialModule } from 'src/app/modules/shared/module/material/material.module';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LogindialogComponent } from './components/logindialog/logindialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SignupdialogComponent } from './components/signupdialog/signupdialog.component';
import { OtpverificationdialogComponent } from './components/otpverificationdialog/otpverificationdialog.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { GradesdialogComponent } from './components/gradesdialog/gradesdialog.component';

import { PasswordLoginDialogComponent } from './components/password-login-dialog/password-login-dialog.component';
import { ForgotPasswordDialogComponent } from './components/forgot-password-dialog/forgot-password-dialog.component';
import { OtpLoginDialogComponent } from './components/otp-login-dialog/otp-login-dialog.component';
import { VerifyOtpDialogComponent } from './components/verify-otp-dialog/verify-otp-dialog.component';
import { SetnewPasswordDialogComponent } from './components/setnew-password-dialog/setnew-password-dialog.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';

import { SetupAccountComponent } from './components/setup-account/setup-account.component';
import { CommonMobileNumberComponent } from './components/common-mobile-number/common-mobile-number.component';
import { BoardsDialogComponent } from './components/boards-dialog/boards-dialog.component';
import { ExamDialogComponent } from './components/exam-dialog/exam-dialog.component';
import { FilterpipePipe } from './pipes/filterpipe.pipe';
import { CountdownModule } from 'ngx-countdown';
import { CountdownComponentComponent } from './components/countdown-component/countdown-component.component';
import { AccountConfirmDialogComponent } from './components/account-confirm-dialog/account-confirm-dialog.component';
import { TermsAndConditionsDialogComponent } from './components/terms-and-conditions-dialog/terms-and-conditions-dialog.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { ConfirmDeleteImageDialogComponent } from './components/confirm-delete-image-dialog/confirm-delete-image-dialog.component';
import { EditPhoneNumberDialogComponent } from './components/edit-phone-number-dialog/edit-phone-number-dialog.component';
import { ConfirmEditPhoneNumberDialogComponent } from './components/confirm-edit-phone-number-dialog/confirm-edit-phone-number-dialog.component';
import { ChangePasswordDialogComponent } from './components/change-password-dialog/change-password-dialog.component';
import { VerifyEmailDialogComponent } from './components/verify-email-dialog/verify-email-dialog.component';
import { ChangePasswordViaOtpDialogComponent } from './components/change-password-via-otp-dialog/change-password-via-otp-dialog.component';
import { VerifyOtpViaChangePasswordDialogComponent } from './components/verify-otp-via-change-password-dialog/verify-otp-via-change-password-dialog.component';
import { MathModule } from './directives/math/math.module';
import { SafePipe } from './pipes/SafePipe';
import { TestComingSoonDialogComponent } from './components/test-coming-soon-dialog/test-coming-soon-dialog.component';
import { TestRegistrationConfirmDialogComponent } from './components/test-registration-confirm-dialog/test-registration-confirm-dialog.component';
import { AdmissionNumberLoginComponent } from './components/admission-number-login/admission-number-login.component';
import { NeetLiveClassDialogComponent } from './components/neet-live-class-dialog/neet-live-class-dialog.component';
import { TestSeriesScheduleComponent } from './components/test-series-schedule/test-series-schedule.component';


import { ClassCardComponent } from './components/class-card/class-card.component';
import { CourseCardComponent } from './components/course-card/course-card.component';
import { ClassListCardComponent } from './components/class-list-card/class-list-card.component';
import { VideoplayerComponent } from './components/videoplayer/videoplayer.component';
import { NoDataPlaceholderComponent } from './components/no-data-placeholder/no-data-placeholder.component';
import { CarouselSharedComponent } from './components/carousel/carousel.component';
import { MomentModule } from 'ngx-moment';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { RouterModule } from '@angular/router';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { IvyCarouselModule } from 'angular-responsive-carousel';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { RegisterDialogComponent } from './components/register-dialog/register-dialog.component';
import { CustomButtonComponent } from './components/custom-button/custom-button.component';
import { LeaveSessionDialogComponent } from './components/live-class-dialog/leave-session-dialog/leave-session-dialog.component';
import { FeedbackDialogComponent } from './components/live-class-dialog/feedback-dialog/feedback-dialog.component';
import { SessionDetailsDialogComponent } from './components/live-class-dialog/session-details-dialog/session-details-dialog.component';
import { ReportIssueDialogComponent } from './components/live-class-dialog/report-issue-dialog/report-issue-dialog.component';
import { RewatchDialogComponent } from './components/live-class-dialog/rewatch-dialog/rewatch-dialog.component';
import { SafeurlpipePipe } from './pipes/safeurlpipe.pipe';
import { CommonDialogComponent } from './components/common-dialog/common-dialog.component';
import CourseTutorCardComponent from './components/course-tutor-card/course-tutor-card.component';
import { CourseBatchCardComponent } from './components/course-batch-card/course-batch-card.component';
import { FaqCardComponent } from './components/faq-card/faq-card.component';
import { TutorExpertiseCardComponent } from './components/tutor-expertise-card/tutor-expertise-card.component';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { PaginatedListComponent } from './components/paginated-list/paginated-list.component';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { LineSkeletonComponent } from './components/loader/line-skeleton/line-skeleton.component';
import { CircleSkeletonComponent } from './components/loader/circle-skeleton/circle-skeleton.component';
import { SquareSkeletonComponent } from './components/loader/square-skeleton/square-skeleton.component';
import { PdfViewerComponent } from './components/pdf-viewer/pdf-viewer.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { TeacherClassCardComponent } from './components/teacher-class-card/teacher-class-card.component';
import { TeacherCourseCardComponent } from './components/teacher-course-card/teacher-course-card.component';
import { PreloaderComponent } from './components/preloader/preloader.component';
import { CourseListCardComponent } from './components/course-list-card/course-list-card.component';
import { CircleProgressBarComponent } from './components/circle-progress-bar/circle-progress-bar.component';

import { NgCircleProgressModule } from 'ng-circle-progress';
import { ListFilterComponent } from './components/list-filter/list-filter.component';
import { ProgressSkeletonLoaderComponent } from './components/loader/progress-skeleton-loader/progress-skeleton-loader.component';
import { CustomVideoPlayerComponent } from './components/custom-video-player/custom-video-player.component';
import { ListViewLoaderComponent } from './components/loader/list-view-loader/list-view-loader.component';
import { TeacherClassCardListComponent } from './components/teacher-class-card-list/teacher-class-card-list.component';
import { UploadDialogComponent } from './components/upload-dialog/upload-dialog.component';
import { DocumentViewerComponent } from './components/document-viewer/document-viewer.component';
import { AudioVideoViewerComponent } from './components/audio-video-viewer/audio-video-viewer.component';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { AutofocusDirective } from './directives/auto-focus.directive';
import { NoDataDashboardLiveclassComponent } from './components/no-data-dashboard-liveclass/no-data-dashboard-liveclass.component';
import { ComingsoonComponent } from './components/comingsoon/comingsoon.component';
import { TestseriesDialogComponent } from './components/testseries-dialog/testseries-dialog.component';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CirclePieChartComponent } from './components/chart/circle-pie-chart/circle-pie-chart.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { HallTicketDialogComponent } from '@app-modules/feature/products/hall-ticket-dialog/hall-ticket-dialog.component';
import { RatingComponent } from './components/rating/rating.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { HeaderComponent } from '@app-core/components/header/header.component';
import { FooterComponent } from '@app-core/components/footer/footer.component';
import { RankDialogComponent } from './components/rank-dialog/rank-dialog.component';
import { SignUpComponent } from './components/auth/sign-up/sign-up.component';
import { SignInComponent } from './components/auth/sign-in/sign-in.component';
import { VerifyOtpComponent } from './components/auth/verify-otp/verify-otp.component';
import { TargetExamComponent } from './components/auth/target-exam/target-exam.component';
import { CreatePasswordComponent } from './components/auth/create-password/create-password.component';
import { PasswordLoginComponent } from './components/auth/password-login/password-login.component';
import { courseHeaderComponent } from './components/header/header.component';
import { courseFooterComponent } from './components/footer/footer.component';
import { OnlyNumberDirective } from './directives/only-number.directive';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { CourseClassListCardComponent } from './components/course-class-list-card/course-class-list-card.component';
import { ChartsModule } from 'ng2-charts';
import { DonutChartComponent } from '@app-modules/feature/dashboard/component/graphs/donut-chart/donut-chart.component';
import { SubscribemodalComponent } from './components/subscribemodal/subscribemodal.component';
import { RatingExperienceDialogComponent } from './components/rating-experience-dialog/rating-experience-dialog.component';
import { QuitConfirmDialogComponent } from './components/quit-confirm-dialog/quit-confirm-dialog.component';
import { ExamFocusDialogComponent } from './components/exam-focus-dialog/exam-focus-dialog.component';
import {EnrollnowComponent} from './components/enrollnow/enrollnow.component';
import {CallbackSuccessComponent} from './components/callback-success/callback-success.component';
import { NewHeaderComponent } from './components/new-header/new-header.component';
import { ZoomImageComponent } from '@app-modules/shared/components/zoom-image/zoom-image.component';

import { OnlyAlphabetsAndSpaceDirective } from './directives/only-alphabets-and-space.directive';
import { SubscribeActiveComponent } from './components/subscribe-active/subscribe-active.component';
import { MmSlashYyDirective } from './directives/mm-slash-yy.directive';
import { FestivalOfferComponent } from './components/festival-offer/festival-offer.component';
import { FestivalPaymentComponent } from './components/festival-payment/festival-payment.component';
import { SuccessHeaderComponent } from './components/success-header/success-header.component';
import { ScoreNewPaymentComponent } from './components/score-new-payment/score-new-payment.component';
import { DiagnosticTestComponent } from './components/diagnostic-test/diagnostic-test.component';
import { DiagnosticThankyouComponent } from './components/diagnostic-thankyou/diagnostic-thankyou.component';
import { ScoreNewThankyouComponent } from './components/score-new-thankyou/score-new-thankyou.component';
import { IntersetedcoursesComponent } from './components/intersetedcourses/intersetedcourses.component';
import { AllmessageComponent } from './components/allmessage/allmessage.component';
import { KnowYourTestComponent } from './components/know-your-test/know-your-test.component';
import { GenericThreeLineMessageModalComponent } from './components/generic-three-line-message-modal/generic-three-line-message-modal.component';
import { JodoPopupInfoDialogComponent } from './components/jodo-popup-info-dialog/jodo-popup-info-dialog.component';
import { ScoreTestReportComponent } from './components/score-test-report/score-test-report.component';
import { DoughnutchartComponent } from '@app-modules/feature/dashboard/component/test-results/test-results/charts/doughnutchart/doughnutchart.component';
import { ScoreReportComponent } from './components/score-report/score-report.component';
import { CuetPaymentComponent } from './components/cuet-payment/cuet-payment.component';
import { SubjectiveTestSubmitFeedbackComponent } from './components/subjective-test-submit-feedback/subjective-test-submit-feedback.component';
import { PaymentalreadypaidComponent } from './components/paymentalreadypaid/paymentalreadypaid.component';
import { SecondstohourPipe } from './pipes/secondstohour.pipe';
import { TimeboundoverviewreportComponent } from './timeboundoverviewreport/timeboundoverviewreport.component';
import { TruncatepipPipe } from './pipes/truncatepip.pipe';
import { NullhandlingPipe } from './pipes/nullhandling.pipe';
import { OnboardingComponent } from './components/auth/onboarding/onboarding.component';
import { ReferralDialogComponent } from './components/referral-dialog/referral-dialog.component';
import { ShareModule } from 'ngx-sharebuttons';
import { YtVideoplayerComponent } from './components/yt-videoplayer/yt-videoplayer.component';
import { PropelldPdfGeneraterComponent } from './components/propelld-pdf-generater/propelld-pdf-generater.component';
import { ScoreCertificateComponent } from './components/score-certificate/score-certificate.component';
import { TermsComponent } from './components/auth/terms/terms.component';

const circleProgressSetting = {
  // SET BASIC SETTING
  maxPercent: 100,
  toFixed: 0,
  showTitle: true,
  showUnits: true,
  showSubtitle: false,
  showImage: false,
  showBackground: false,
  showInnerStroke: true,
  clockwise: true,
  responsive: false,
  startFromZero: true,
  showZeroOuterStroke: false,
  // SET SIZE SETTING
  radius: 51.5,
  backgroundPadding: 0,
  imageHeight: 20,
  imageWidth: 20,
  // SET COLOR SETTING
  backgroundGradient: false,
  backgroundOpacity: 1,
  backgroundColor: 'transparent',
  backgroundGradientStopColor: 'transparent',
  backgroundStroke: 'transparent',
  outerStrokeGradient: false,
  outerStrokeColor: "#48bc94",
  outerStrokeGradientStopColor: 'transparent',
  innerStrokeColor: "#c6e8dc",
  titleColor: "#000000",
  unitsColor: '#000000',
  subtitleColor: '#000000',
  // SET STROKE
  outerStrokeWidth: 5,
  space: -5,
  innerStrokeWidth: 5,
  backgroundStrokeWidth: 0,
  outerStrokeLinecap: 'round',
  // SET FONT SIZE SETTING
  titleFontSize: '20',
  unitsFontSize: '20',
  subtitleFontSize: '10',
  titleFontWeight: '500',
  unitsFontWeight: '500',
  subtitleFontWeight: '500',
  // SET ANIMATION
  animation: true,
  animateTitle: true,
  lazy: false,
  animationDuration: 500,
}

@NgModule({
  declarations: [
    LogindialogComponent,
    PasswordLoginDialogComponent,
    ForgotPasswordDialogComponent,
    OtpLoginDialogComponent,
    VerifyOtpDialogComponent,
    SetnewPasswordDialogComponent,
    OtpverificationdialogComponent,
    GradesdialogComponent,
    SignupdialogComponent,
    SetupAccountComponent,
    CommonMobileNumberComponent,
    BoardsDialogComponent,
    ExamDialogComponent,
    HallTicketDialogComponent,
    FilterpipePipe,
    SafePipe,
    AutofocusDirective,
    CountdownComponentComponent,
    AccountConfirmDialogComponent,
    TermsAndConditionsDialogComponent,
    ConfirmDialogComponent,
    ConfirmDeleteImageDialogComponent,
    EditPhoneNumberDialogComponent,
    ConfirmEditPhoneNumberDialogComponent,
    ChangePasswordDialogComponent,
    VerifyEmailDialogComponent,
    ChangePasswordViaOtpDialogComponent,
    VerifyOtpViaChangePasswordDialogComponent,
    TestComingSoonDialogComponent,
    TestRegistrationConfirmDialogComponent,
    AdmissionNumberLoginComponent,
    NeetLiveClassDialogComponent,
    TestSeriesScheduleComponent,
    ClassCardComponent,
    CourseCardComponent,
    ClassListCardComponent,
    VideoplayerComponent,
    NoDataPlaceholderComponent,
    CarouselSharedComponent,
    RegisterDialogComponent,
    CustomButtonComponent,
    LeaveSessionDialogComponent,
    FeedbackDialogComponent,
    SessionDetailsDialogComponent,
    ReportIssueDialogComponent,
    RewatchDialogComponent,
    SafeurlpipePipe,
    CommonDialogComponent,
    CourseTutorCardComponent,
    CourseBatchCardComponent,
    TutorExpertiseCardComponent,
    FaqCardComponent,
    PaginatedListComponent,
    LineSkeletonComponent,
    CircleSkeletonComponent,
    SquareSkeletonComponent,
    PdfViewerComponent,
    TeacherClassCardComponent,
    TeacherCourseCardComponent,
    PreloaderComponent,
    CourseListCardComponent,
    CircleProgressBarComponent,
    ListFilterComponent,
    TestseriesDialogComponent,
    ProgressSkeletonLoaderComponent,
    CustomVideoPlayerComponent,
    ListViewLoaderComponent,
    TeacherClassCardListComponent,
    UploadDialogComponent,
    DocumentViewerComponent,
    AudioVideoViewerComponent,
    NoDataDashboardLiveclassComponent,
    ComingsoonComponent,
    DatePickerComponent,
    CirclePieChartComponent,
    RatingComponent,
    ConfirmationDialogComponent,
    HeaderComponent,
    FooterComponent,
    RankDialogComponent,
    SignUpComponent,
    SignInComponent,
    VerifyOtpComponent,
    TargetExamComponent,
    CreatePasswordComponent,
    PasswordLoginComponent,
    courseHeaderComponent,
    courseFooterComponent,
    OnlyNumberDirective,
    PrivacyPolicyComponent,
    CourseClassListCardComponent,
    DonutChartComponent,
    SubscribemodalComponent,
    RatingExperienceDialogComponent,
    QuitConfirmDialogComponent,
    ExamFocusDialogComponent,
    EnrollnowComponent,
    CallbackSuccessComponent,
    NewHeaderComponent,
    ZoomImageComponent,
    OnlyAlphabetsAndSpaceDirective,
    SubscribeActiveComponent,
    MmSlashYyDirective,
    FestivalOfferComponent,
    FestivalPaymentComponent,
    SuccessHeaderComponent,
    ScoreNewPaymentComponent,
    DiagnosticTestComponent,
    DiagnosticThankyouComponent,
    ScoreNewThankyouComponent,
    IntersetedcoursesComponent,
    AllmessageComponent,
    KnowYourTestComponent,
    GenericThreeLineMessageModalComponent,
    JodoPopupInfoDialogComponent,
    ScoreTestReportComponent,
    DoughnutchartComponent,
    ScoreReportComponent,
    CuetPaymentComponent,
    SubjectiveTestSubmitFeedbackComponent,
    PaymentalreadypaidComponent,
    SecondstohourPipe,
    TimeboundoverviewreportComponent,
    TruncatepipPipe,
    NullhandlingPipe,
    OnboardingComponent,
    ReferralDialogComponent,
    YtVideoplayerComponent,
    PropelldPdfGeneraterComponent,
    ScoreCertificateComponent,
    TermsComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    NgOtpInputModule,
    NgxIntlTelInputModule,
    CountdownModule,
    MathModule,
    MomentModule,
    TooltipModule.forRoot(),
    TabsModule.forRoot(),
    IvyCarouselModule,
    BsDropdownModule.forRoot(),
    PaginationModule.forRoot(),
    ButtonsModule.forRoot(),
    RouterModule,
    PdfViewerModule,
    NgxDocViewerModule,
    NgCircleProgressModule.forRoot(circleProgressSetting),
    ModalModule.forRoot(),
    MatDatepickerModule,
    NgApexchartsModule,
    ChartsModule,
    ShareModule
  ],
  exports: [
    MaterialModule,
    LogindialogComponent,
    OtpverificationdialogComponent,
    HallTicketDialogComponent,
    CommonMobileNumberComponent,
    MathModule,
    SafePipe,
    AutofocusDirective,
    ClassCardComponent,
    CourseCardComponent,
    ClassListCardComponent,
    NoDataPlaceholderComponent,
    TooltipModule,
    TabsModule,
    IvyCarouselModule,
    CarouselSharedComponent,
    BsDropdownModule,
    SafeurlpipePipe,
    CustomButtonComponent,
    FaqCardComponent,
    TutorExpertiseCardComponent,
    PaginationModule,
    PaginatedListComponent,
    CourseTutorCardComponent,
    ButtonsModule,
    LineSkeletonComponent,
    CircleSkeletonComponent,
    SquareSkeletonComponent,
    TeacherClassCardComponent,
    TeacherCourseCardComponent,
    PreloaderComponent,
    CourseListCardComponent,
    ListFilterComponent,
    ConfirmationDialogComponent,
    ProgressSkeletonLoaderComponent,
    CustomVideoPlayerComponent,
    ListViewLoaderComponent,
    ListViewLoaderComponent,
    TeacherClassCardListComponent,
    UploadDialogComponent,
    NoDataDashboardLiveclassComponent,
    DatePickerComponent,
    ModalModule,
    CirclePieChartComponent,
    RatingComponent,
    CirclePieChartComponent,
    HeaderComponent,
    FooterComponent,
    SignUpComponent,
    SignInComponent,
    VerifyOtpComponent,
    TargetExamComponent,
    CreatePasswordComponent,
    PasswordLoginComponent,
    courseHeaderComponent,
    courseFooterComponent,
    OnlyNumberDirective,
    CourseClassListCardComponent,
    DonutChartComponent,
    NewHeaderComponent,
    OnlyAlphabetsAndSpaceDirective,
    MmSlashYyDirective,
    SuccessHeaderComponent,
    DoughnutchartComponent,
    SecondstohourPipe,
    TimeboundoverviewreportComponent,
    TruncatepipPipe,
    NullhandlingPipe,
    YtVideoplayerComponent
  ],
  entryComponents: [
    OtpverificationdialogComponent,
    LogindialogComponent,
    PasswordLoginDialogComponent,
    ForgotPasswordDialogComponent,
    OtpLoginDialogComponent,
    VerifyOtpDialogComponent,
    SetnewPasswordDialogComponent,
    BoardsDialogComponent,
    CommonMobileNumberComponent,
    AccountConfirmDialogComponent,
    TermsAndConditionsDialogComponent,
    ConfirmDialogComponent,
    EditPhoneNumberDialogComponent,
    ConfirmEditPhoneNumberDialogComponent,
    VerifyEmailDialogComponent,
    NeetLiveClassDialogComponent,
    DoughnutchartComponent,
    ScoreCertificateComponent
  ],
  providers: [
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} }, DatePipe
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SharedModule { }


